import firebase from 'firebase/compat/app'
import HttpStatus from 'http-status-codes'

import { config } from '../../components/Init/Init'

const checkPromoCodeApi = (socialData, promoCode, onSuccess, onFail) => {
  if (!promoCode) {
    return true
  }

  return fetch(socialData.wsBaseUrl + '/' + config.verifyPromoCodeUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ApplicationToken: socialData.applicationToken
    },
    body: JSON.stringify({
      accountId: socialData.accountId,
      applicationId: config.applicationId,
      promoCode: promoCode,
      skipClientNotification: false
    })
  })
    .then(res => {
      if (res.status === HttpStatus.OK) {
        return res.json().then(data => {
          if (data.rewards && data.rewards.length) {
            onSuccess()
            return true
          } else {
            onFail()
            return false
          }
        })
      } else {
        onFail()
        return false
      }
    })
    .catch(error => {
      console.log('[Promo Code] Error validating user Promo Code on social api: ', error)
      onFail()
      return false
    })
}

const redeemPromoCode = (socialData, promoCode) => {
  if (!socialData || !socialData.applicationToken) {
    return
  }

  fetch(socialData.wsBaseUrl + '/' + config.redeemPromoCodeUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ApplicationToken: socialData.applicationToken
    },
    body: JSON.stringify({
      accountId: socialData.accountId,
      applicationId: config.applicationId,
      promoCode: promoCode,
      skipClientNotification: false
    })
  }).catch(error => console.log('[Promo Code] Error redeeming user Promo Code on social api: ', error))
}

const setFirebaseUserPromoCode = async promoCode => {
  let setUserPromoCodeFirebaseFunc = firebase
    .functions()
    .httpsCallable('setUserPromoCode' + config.firebaseCloudFunctionSuffix)

  try {
    await setUserPromoCodeFirebaseFunc({
      promoCode: promoCode,
      firebaseDb: config.firebaseDb
    })
  } catch (err) {
    console.log(`[Promo Code] Error updating user Promo Code on Firebase: ${err}`)
  }
}

export { setFirebaseUserPromoCode, redeemPromoCode, checkPromoCodeApi }
